var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9637 3.6001C23.8786 4.03751 23.8362 4.48212 23.837 4.92771C23.837 8.92549 27.0826 12.1663 31.0863 12.1663C31.5271 12.1642 31.9669 12.1218 32.4 12.0399V26.3907C32.4 32.4282 28.8387 36.0001 22.7924 36.0001H9.62345C3.56131 36.0001 0 32.4282 0 26.3907V13.2411C0 7.20361 3.56131 3.6001 9.62345 3.6001H23.9637ZM24.1812 14.3898L23.97 14.403C23.618 14.4536 23.3016 14.6445 23.0931 14.9322L18.7562 20.5113L13.8179 16.6233C13.5359 16.4037 13.1773 16.3067 12.8229 16.3543C12.4684 16.4018 12.1482 16.59 11.9343 16.8762L6.61612 23.7355C6.42919 23.9685 6.32855 24.2588 6.33122 24.5574L6.33589 24.756C6.38744 25.278 6.74547 25.7291 7.25828 25.8909C7.83519 26.0731 8.46248 25.8433 8.78456 25.3318L13.2322 19.5788L18.1706 23.451C18.4515 23.6775 18.8125 23.7801 19.1707 23.7354C19.5289 23.6907 19.8535 23.5025 20.07 23.214L25.2141 16.5759V16.5443C25.6544 15.9525 25.5421 15.1181 24.9608 14.6635C24.6795 14.4463 24.322 14.3523 23.97 14.403L24.1812 14.3898Z",
    fill: "#00825A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.5 9C33.9853 9 36 6.98528 36 4.5C36 2.01472 33.9853 0 31.5 0C29.0147 0 27 2.01472 27 4.5C27 6.98528 29.0147 9 31.5 9Z",
    fill: "#00825A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.706df48b5d849602a8b526a683ad38e5.svg";
export { ForwardRef as ReactComponent };